import React from "react";
import "./Footer.css";

const Footer = () => {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-text">
            <p>© 2025 Lotopim. Todos os direitos reservados.</p>
            <p>by CHF Serviços Digitais ME</p>
            <p className="disclaimer">
              Não temos qualquer vínculo com a Caixa Econômica Federal ou loterias da Caixa. 
              Jogue com responsabilidade.
            </p>
          </div>
          {/* REMOVIDA a seção de redes sociais */}
        </div>
      </div>
    </footer>
  );
};

export default Footer;